// Date-range presets for the dashboard. Each maps to a {from, to} pair of
// YYYY-MM-DD strings the API takes as `from`/`to`. A custom range (the date
// pickers) bypasses these.

export type RangeKey = '7d' | '30d' | '90d' | '12m' | 'ytd' | 'all';

export const RANGES: Array<{ key: RangeKey; label: string }> = [
  { key: '7d', label: '7D' },
  { key: '30d', label: '30D' },
  { key: '90d', label: '90D' },
  { key: '12m', label: '12M' },
  { key: 'ytd', label: 'YTD' },
  { key: 'all', label: 'All' },
];

export const iso = (d: Date): string => d.toISOString().slice(0, 10);

export function rangeToDates(key: RangeKey): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to);
  switch (key) {
    case '7d':
      from.setDate(to.getDate() - 7);
      break;
    case '30d':
      from.setDate(to.getDate() - 30);
      break;
    case '90d':
      from.setDate(to.getDate() - 90);
      break;
    case '12m':
      from.setFullYear(to.getFullYear() - 1);
      break;
    case 'ytd':
      from.setMonth(0, 1);
      break;
    case 'all':
      from.setFullYear(2000, 0, 1);
      break;
  }
  return { from: iso(from), to: iso(to) };
}
